// extracted by mini-css-extract-plugin
export default {"highlightFirstLetter":"HighlightFirstNumber__highlightFirstLetter--R2mphj"};